module.exports = __webpack_public_path__ + "img/task_filled_outlined.3471e448.svg";